import type { Notification } from "~types/notification";
import BasePopoverNotificationItem from "./BasePopoverNotificationItem";

type Props = {
  notification: Notification;
  onClick: (notification: Notification) => void;
};

const ImportPopoverNotificationItem = ({ notification, onClick }: Props) => {
  return <BasePopoverNotificationItem notification={notification} onClick={onClick} icon="fa-file-import" />;
};

export default ImportPopoverNotificationItem;
